import { shouldShowField } from '../../components/CruiseBooking/AdditionalCheckoutFields';
import { logErrorToConsole } from '../../constants';

const validateCheckoutFields = (checkoutFields, selectedFields) => {
  const errors = checkoutFields.reduce((acc, field) => {
    const {
      key, isRequiredField, maxLength, regexRule,
    } = field;
    const value = selectedFields[key];

    const isVisible = shouldShowField(field, selectedFields);

    // Required field check
    if (isRequiredField && isVisible && (!value || value.toString().trim() === '')) {
      acc[key] = `${field.fieldName} is required.`;
      return acc;
    }

    // Max length check
    if (maxLength && value && value.length > maxLength) {
      acc[key] = `${field.fieldName} must be at most ${maxLength} characters.`;
      return acc;
    }

    // Regex check
    if (regexRule && value) {
      try {
        const regex = new RegExp(regexRule.slice(1, -1)); // remove surrounding slashes
        if (!regex.test(value)) {
          acc[key] = `${field.fieldName} is invalid.`;
        }
      } catch (err) {
        logErrorToConsole(`Invalid regex for ${key}: ${regexRule}`);
      }
    }

    return acc;
  }, {});

  return errors;
};

export default validateCheckoutFields;
